import { useQuery } from "@tanstack/react-query";
import { getWhyChooseUsItems } from "../../api/apiWhyChooseUs";
import i18next from "i18next";

export function useGetWhyChooseUsItems(params = {}) {
    const { isLoading, data, error, refetch } = useQuery({
        queryKey: ["why-choose-us-items", params, i18next.language],
        queryFn: () => getWhyChooseUsItems(params),
        retry: false,
    });

    const items = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params.per_page || 15, total: 0 };

    return { isLoading, error, items, meta, refetch };
}
